/**
 * Copyright (c) 2018 Mathis Zeiher
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

import { CustomElement } from '../customelement';
import { renderToShadowDOM } from './shadowDOMRenderer';
import { renderToLightDOM } from './lightDOMRenderer';
import { PROPERTY_STATE } from '../propertystate';

 /**
  * renders the component
  */
export function renderComponent(this: CustomElement) {
    this.componentWillRender();
    this._renderScheduled = false;
    const elementToRender = this.renderToElement();
    if (elementToRender === this.shadowRoot) { // render to shadowroot
      renderToShadowDOM.apply(this, [elementToRender]);
    } else {
      renderToLightDOM.apply(this, [elementToRender]);
    }
    this.componentDidRender();
    if (this._firstRender) {
      this.componentFirstRender();
      this._firstRender = false;
    }
    this._propertyState = PROPERTY_STATE.UPDATED;
    this._renderCompletedCallbacks.forEach((value) => value());
    this._renderCompletedCallbacks = [];
    if (this._layoutRAFReference === null) { // queue a promise which resolves after browser layouting
      this._layoutRAFReference = window.requestAnimationFrame(() => {
        Promise.resolve().then(() => {
          this.componentDidLayout();
          this._layoutRAFReference = null;
        });
      });
    }
  }
